module.exports = __webpack_public_path__ + "static/media/firefox-logo.49161824.png";